export default __webpack_public_path__ + "static/media/python_nptel.c8e86a20.png";